// @ vendors
const { Promise } = require('es6-promise');
// @ constants
const actionTypes = require('constants/actionTypes');
// @ utilities
const {APIGet} = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');
// @ actions
const {requestCards} = require('actions/getMyCards');
const {requestCardStatements} = require('actions/getCardsStatements');

const requestCardStatementDetailsRequest = (cardId, statementId) => ({
    type: actionTypes.FETCH_CARDS_STATEMENT_DETAILS_REQUEST,
    payload: {cardId, statementId}
});

const requestCardStatementDetailsFailure = (cardId, statementId, error) =>({
    type: actionTypes.FETCH_CARDS_STATEMENT_DETAILS_FAILURE,
    payload: {cardId, statementId, error: error}
});

const requestCardStatementDetailsSuccess = (cardId, statementId, data) => ({
    type: actionTypes.FETCH_CARDS_STATEMENT_DETAILS_SUCCESS,
    payload: {
        cardId,
        statementId,
        details: data || {}
    }
});

const getCardStatementDetails = (dispatch, getState, cardId, statementId) =>
    dispatch(requestCards())
    .then(() => dispatch(requestCardStatements(cardId))
    .then(() => {
        const immCard = getState().cards.get('byId').get(cardId);
        const immStatement = getState().cardsStatements.getIn([cardId, 'byId', statementId]);

        const requestData = {
            query: {
                producto: immCard.getIn(['contract', 'product']),
                numeroContrato: immCard.getIn(['contract', 'number']),
                fecprlqt: immStatement.get('date'),
                estado: immStatement.get('status'),
                diaMovto: immStatement.get('movementDay'),
                divisa: immStatement.get('amount').get('currency'),
                importe: immStatement.get('amount').get('amount')
            }
        };
        dispatch(requestCardStatementDetailsRequest(cardId, statementId));
        return APIGet(
            dispatch,
            apiURLBuilder.getURL('cardStatementDetails'),
            requestData)
        .then(
            response => dispatch(requestCardStatementDetailsSuccess(cardId, statementId, response)),
            error => dispatch(requestCardStatementDetailsFailure(cardId, statementId, error))
        );
    }));

const requestCardStatementDetails = (cardId, statementId) => (dispatch, getState) => {
    const immStatementDetailsObj = getState().cardsStatementDetails;

    if (immStatementDetailsObj.size === 0 || !immStatementDetailsObj.get(statementId)) {
        const immStatementDetails = immStatementDetailsObj.get(statementId);

        if (!immStatementDetails || (!immStatementDetails.get('loading') && !immStatementDetails.get('error')) ) {
            return getCardStatementDetails(dispatch, getState, cardId, statementId);
        }
    }
    return Promise.resolve();
};

module.exports = {
    requestCardStatementDetails
}
